export const config = {
    apiKey: "AIzaSyDWf0jHENs-lxpZIRQ1kiAPJ7JVS3U8BqY",
    authDomain: "expertdebugging.firebaseapp.com",
    databaseURL: "https://expertdebugging.firebaseio.com",
    projectId: "expertdebugging",
    storageBucket: "expertdebugging.appspot.com",
    messagingSenderId: "193787009099",
    appId: "1:193787009099:web:240990e604d8e8e34bd5ce",
    measurementId: "G-BL46RP9Z74"
  };